module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/store_images/5_3af52982f7a6eba931c17dda73ade591.png";